import type { ModuleSnapshot } from '@ctcells/contract'

/**
 * 모듈 **등록 수명**(`service_state`) 한 가지만 보는 자리.
 *
 * 🔴 **고장과 폐기는 다른 사실이다.** `stale`(응답 없음)은 「지금 안 보인다」이고
 *    `service_state === 'terminated'` 는 「**이 장비는 더 이상 없다**」다. 2026-09-20 이전에는
 *    둘을 가를 값이 응답에 없어서 폐기된 `mock-*` 4대가 목록에 「응답 없음」으로 섞여 있었다
 *    (`docs/backend-requests.csv` BR-01). 백엔드가 그 값을 실어 주면서 풀렸다.
 *
 * 🔴 **칸이 없으면 «감추지 않는다» — 다만 `active` 라고 읽지도 않는다**(계약 원문 「부재를 `active` 로
 *    읽지 않는다 · 칸이 없는 응답은 "이 판이 그 값을 안 싣는다"」 · 2026-09-26 생성 타입에 칸이 섰다).
 *    모르는 모듈을 폐기로 보고 지우면 「있는 장비가 사라진다」가 되고, 그쪽이 더 나쁜 오류다 —
 *    판정은 **`'terminated'` 와 같을 때 하나로만** 한다. 이 함수는 「폐기인가」만 답하고
 *    「운용 중이다」를 단언하지 않는다(화면에 그 낱말을 적지 않는다 · `moduleNewFields.test.tsx`).
 *
 * 🔴 **이름(`mock-` 접두어)으로 거르지 마라.** 이름으로 상태를 추론하는 것은 규약 위반이고,
 *    운영에서 접두어가 바뀌면 조용히 틀린다. 판정은 서버가 준 «값»으로만 한다.
 */
export function isTerminated(module: Pick<ModuleSnapshot, 'service_state'>): boolean {
  return module.service_state === 'terminated'
}

/** 운용 중인 모듈만. 목록·고르기가 **먼저** 이걸 통과시킨다 */
export function activeModules<T extends Pick<ModuleSnapshot, 'service_state'>>(
  modules: readonly T[],
): readonly T[] {
  return modules.filter((module) => !isTerminated(module))
}
